import React from "react";
import FormOptionInput from "../FormOptionInput";
import FormOptionRadio from "../FormOptionRadio";
import FormOptionBtn from "../FormOptionsBtn";
import FormOptionDropdown from "../FormOptionDropdown";
import FormOptionCheckbox from "../FormOptionCheckbox";
import { Radio } from "antd";
import trans, { isRTL } from "../../../../../utils";

export default function FormOptionMain({
	activeInput,
	activeItem,
	updateActiveItem,
	setOthers,
	others,
	addForm,
	submitAttempt,
	localErrors,
	setLocalErrors,
}) {
	const activeIndex = addForm.values.formSchema.fields.findIndex(
		(field) => field.key === activeItem.key
	);

	let containerIndex = null;
	let innerIndex = null;
	let containerTitle = null;
	let containerImg = null;
	let containerLink = null;

	addForm.values.formSchema.fields.forEach((field, i) => {
		if (field.name === "Container") {
			const indexInside = field.container?.findIndex(
				(j) => j.key === activeItem.key
			);
			if (indexInside !== -1) {
				containerIndex = i;
				innerIndex = indexInside;
				containerTitle = field.container[indexInside]?.title;
				containerImg = field.container[indexInside]?.imgPath;
				containerLink = field.container[indexInside]?.hyperLink;
			}
		}
	});

	const titleFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.title ?? containerTitle;
	const ImgFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.imgPath ?? containerImg;
	const LinkFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.hyperLink ?? containerLink;
	const showInitialName = !titleFromFormik && titleFromFormik !== "";

	function getFieldMeta(fieldName) {
		console.log("Field Name", fieldName);
		const isInContainer = containerIndex !== null;

		const path = isInContainer
			? `formSchema.fields[${containerIndex}].container[${innerIndex}]`
			: `formSchema.fields[${activeIndex}]`;

		const fullPath = fieldName.includes(".")
			? `${path}.${fieldName}`
			: `${path}.${fieldName}`;

		const value = fieldName
			.split(".")
			.reduce(
				(obj, key) => obj?.[key],
				isInContainer
					? addForm.values.formSchema.fields?.[containerIndex]?.container?.[
							innerIndex
					  ]
					: addForm.values.formSchema.fields?.[activeIndex]
			);

		const error = fieldName
			.split(".")
			.reduce(
				(obj, key) => obj?.[key],
				isInContainer
					? addForm.errors.formSchema?.fields?.[containerIndex]?.container?.[
							innerIndex
					  ]
					: addForm.errors.formSchema?.fields?.[activeIndex]
			);

		const touched = fieldName
			.split(".")
			.reduce(
				(obj, key) => obj?.[key],
				isInContainer
					? addForm.touched.formSchema?.fields?.[containerIndex]?.container?.[
							innerIndex
					  ]
					: addForm.touched.formSchema?.fields?.[activeIndex]
			);

		return {
			value,
			error,
			touched,
			path: fullPath,
		};
	}

	const titleMeta = getFieldMeta("title");

	// Conditional meta getters (only call when needed)
	const hyperLinkMeta =
		activeItem.name === "Link" ? getFieldMeta("hyperLink") : null;

	const imgPathMeta =
		activeItem.name === "Image" ? getFieldMeta("imgPath") : null;
	const ContainerMeta =
		activeItem.name === "Container" ? getFieldMeta("container") : null;
	const validationMeta =
		activeItem.required && typeof activeItem.required === "object"
			? getFieldMeta("required.validationMessage")
			: null;

	const handleBlur = (path) => {
		addForm.setFieldTouched(path, true, true);
	};
	console.log("ContainerMeta", ContainerMeta);

	return (
		<>
			<h3 style={{ textAlign: isRTL ? "right" : "left" }}>
				{trans("Field Settings")}
			</h3>
			<div className="task-option-item">
				<label htmlFor="key" className="form-label">
					{trans("Key")}
				</label>
				<div>{activeInput || trans("No input selected")}</div>
			</div>

			{activeItem.name !== "Container" && activeItem.name !== "Image" && (
				<FormOptionInput
					title={trans("Title")}
					placeholder={trans("Enter input title")}
					name={titleMeta.path}
					id={titleMeta.path}
					value={showInitialName ? activeItem.name : titleFromFormik}
					onChange={(e) => {
						updateActiveItem("title", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(titleMeta.path)}
					errors={!showInitialName && titleMeta.touched && titleMeta.error}
					touched={!showInitialName && titleMeta.touched}
				/>
			)}

			{(activeItem.name === "Input" ||
				activeItem.name === "Text_area" ||
				activeItem.name === "Dropdown") && (
				<FormOptionInput
					title={trans("Placeholder")}
					placeholder={trans("Enter input placeholder")}
					value={activeItem.placeholder}
					onChange={(e) => updateActiveItem("placeholder", e.target.value)}
				/>
			)}

			{activeItem.name === "Input" && (
				<div className="task-option-item">
					<label htmlFor={activeItem.name} className="form-label">
						{trans("Input Type")}
					</label>
					<Radio.Group
						style={{ display: "flex", flexDirection: "row", gap: 24 }}
						value={activeItem.inputType}
						onChange={(e) => updateActiveItem("inputType", e.target.value)}
						options={[
							{ label: trans("Text"), value: "text" },
							{ label: trans("Number"), value: "number" },
						]}
					/>
				</div>
			)}

			{activeItem.name === "Link" && (
				<FormOptionInput
					title={trans("Link")}
					placeholder={trans("Enter hyperLink")}
					name={hyperLinkMeta.path}
					id={hyperLinkMeta.path}
					value={LinkFromFormik || ""}
					onChange={(e) => {
						updateActiveItem("hyperLink", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(hyperLinkMeta.path)}
					errors={hyperLinkMeta.touched && hyperLinkMeta.error}
					touched={hyperLinkMeta.touched}
				/>
			)}

			{activeItem.name === "Image" && (
				<FormOptionInput
					title={trans("Image Link")}
					placeholder={trans("Enter Image Link")}
					name={imgPathMeta.path}
					id={imgPathMeta.path}
					value={ImgFromFormik || ""}
					onChange={(e) => {
						updateActiveItem("imgPath", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(imgPathMeta.path)}
					errors={imgPathMeta.touched && imgPathMeta.error}
					touched={imgPathMeta.touched}
				/>
			)}

			{![
				"Toggle",
				"Button",
				"Checkbox",
				"Container",
				"Image",
				"Header",
				"Label",
				"Link",
				"Progress_line",
				"Progress_circle",
			].includes(activeItem.name) && (
				<>
					<FormOptionCheckbox
						title={trans("Required")}
						id={activeItem?.key}
						value={activeItem?.required?.value}
						onChange={(e) =>
							updateActiveItem("required.value", e.target.checked)
						}
					/>

					{activeItem.required?.value && (
						<FormOptionInput
							title={trans("Validation Message")}
							placeholder={trans("Enter validation message")}
							name={validationMeta.path}
							id={validationMeta.path}
							value={trans(validationMeta.value)}
							onChange={(e) => {
								updateActiveItem("required.validationMessage", e.target.value);
								addForm.handleChange(e);
							}}
							onBlur={() => handleBlur(validationMeta.path)}
							errors={validationMeta.touched && validationMeta.error}
							touched={validationMeta.touched}
						/>
					)}
				</>
			)}

			{activeItem.name === "Radio_group" && (
				<FormOptionRadio
					id={activeItem?.key}
					radioOptions={activeItem?.radioOptions}
					onChange={(e) => updateActiveItem("radioOptions", e.target.value)}
					addForm={addForm}
					setLocalErrors={setLocalErrors}
					localErrors={localErrors}
				/>
			)}

			{activeItem.name === "Button" && (
				<FormOptionBtn
					id={activeItem?.key}
					onChange={(e) => updateActiveItem("btnType", e.target.value)}
				/>
			)}

			{activeItem.name === "Dropdown" && (
				<FormOptionDropdown
					id={activeItem?.key}
					dropdownOptions={activeItem?.dropdownOptions.data}
					queryKey={activeItem?.dropdownOptions.queryKey}
					setOthers={setOthers}
					others={others}
					onChange={(e) => updateActiveItem("dropdownOptions", e.target.value)}
					dropdowns={addForm.values.formSchema.fields.filter(
						(item) => item.name === "Dropdown"
					)}
					addForm={addForm}
					setLocalErrors={setLocalErrors}
					localErrors={localErrors}
				/>
			)}
			{activeItem.name === "Container" &&
				(!activeItem.container || activeItem.container.length === 0) &&
				submitAttempt && (
					<div className="text-danger" style={{ marginTop: 4, fontSize: 12 }}>
						{trans("Container must have at least one input")}
					</div>
				)}
		</>
	);
}
